import { TableCell } from '@creditas/table'
import { styled, css } from '@creditas/stylitas'

const cellDisabled = ({ disabled }: { disabled: boolean }) =>
  disabled
    ? css`
        color: rgb(170, 187, 187);
      `
    : css`
        &:hover {
          background-color: #ddeeff;
          border: 1px solid #3377bb !important;
        }
      `

const cellWidth = ({ width }: { width?: string | number }) =>
  width &&
  css`
    width: ${`${width}${typeof width === 'number' ? 'px' : ''}`};
  `

const TableCellHead = styled(TableCell)<{
  width?: string | number
  disabled: boolean
  onClick?: () => void
}>`
  border-left: 1px solid transparent;
  cursor: pointer;
  padding: 12px;
  text-align: left;

  &:first-of-type {
    border-left: 1px solid #eee;
  }

  ${cellWidth}
  ${cellDisabled}
`

const CustomCell = styled(TableCell)<{ textRight?: boolean }>`
  padding: 24px 20px;
  ${({ textRight }) => textRight && 'text-align: right;'}
`

export { TableCellHead, CustomCell as TableCell }
